// src/features/customers/components/CustomerRow.tsx
import { useNavigate } from 'react-router-dom';
import type { Customer } from '../customer.types';
import { CustomerStatusBadge } from './CustomerStatusBadge';

interface CustomerRowProps {
  customer: Customer;
}

export function CustomerRow({ customer }: CustomerRowProps) {
  const navigate = useNavigate();
  const initial = customer.name.trim().charAt(0).toUpperCase();

  const goToDetails = () => navigate(`/customers/${customer.id}`);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={goToDetails}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goToDetails();
        }
      }}
      className="flex cursor-pointer items-center gap-3 px-5 py-3.5 transition-colors hover:bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.03))]"
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.08))] text-xs font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
        {initial}
      </span>

      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-[var(--vania-colors-text-primary,#f5f6fa)]">
          {customer.name}
        </p>
        <p className="truncate text-xs text-[var(--vania-colors-text-secondary,#a3aab8)]">
          {customer.contact}
        </p>
      </div>

      <span className="shrink-0 text-xs text-[var(--vania-colors-text-secondary,#a3aab8)]">
        {customer.activeServicesCount} سرویس فعال
      </span>

      <CustomerStatusBadge status={customer.status} />
    </div>
  );
}
